import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { DatablockActionPopupComponent } from './components/datablock-action-popup/datablock-action-popup.component';
import { DatablockListComponent } from './components/datablock-list/datablock-list.component';
import { DatablockAdapter } from './datablock.adapter';
import {
	DatablockEffects,
	DatablockFeatureKey,
	datablockReducers,
	DatablockSelector,
} from './store';

@NgModule({
	declarations: [DatablockListComponent, DatablockActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(DatablockFeatureKey, datablockReducers),
		EffectsModule.forFeature([DatablockEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcBadgeModule,
		DcAvatarModule,
		DcBreadcrumbModule,
		DcButtonModule,
	],
	providers: [DatablockAdapter, DatablockSelector],
})
export class DatablockModule {
	public constructor(private readonly injector: Injector) {
		const datablockListCmpElement = createCustomElement(
			DatablockListComponent,
			{
				injector,
			}
		);
		customElements.define('app-datablock-list', datablockListCmpElement);
	}
}
